import React, { Component } from 'react';

// Be sure to include styles at some point, probably during your bootstraping

import SideNavs from '../SideNavs'

import AdminTable from './AdminTable';
class Main extends Component {
    render() { 
 
        return ( 
           
                <div>
          
              <SideNavs></SideNavs>
      
          
                <AdminTable/>
                 </div>
         
         );
    }
}
 
export default Main;